<template>
  <div class="env">
    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-setstar.svg">体感温度
      </div>
      <div class="center">
        {{ editValueToDisplay(destinationSpotState.setstar, 10) }} ℃
      </div>
    </v-ons-list-item>

    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-noise.svg">にぎわい度
      </div>
      <div class="center">
        {{ noiseCalculated(destinationSpotState.noise) }}
      </div>
    </v-ons-list-item>

    <!-- TODO: フェア中のみ削除 -->
    <!--
    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-congestion.svg">混雑度
      </div>
      <div class="center">
        {{ editValueToDisplay(destinationSpotState.congestionDegree, 1) }} %
      </div>
    </v-ons-list-item>
    -->

    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-temperature.svg">温度
      </div>
      <div class="center">
        {{ editValueToDisplay(destinationSpotState.temperature, 10) }} ℃
      </div>
    </v-ons-list-item>

    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-humidity.svg">湿度
      </div>
      <div class="center">
        {{ editValueToDisplay(destinationSpotState.humidity, 1) }} %
      </div>
    </v-ons-list-item>

    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-wind_speed.svg">風速
      </div>
      <div class="center">
        {{ editValueToDisplay(destinationSpotState.windSpeed, 10) }} m/s
      </div>
    </v-ons-list-item>

    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-globe_temperatue.svg">黒球温度
      </div>
      <div class="center">
        {{ editValueToDisplay(destinationSpotState.globeTemperature, 10) }} ℃
      </div>
    </v-ons-list-item>

    <!-- TODO: フェア中のみ削除 -->
    <!--
    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-illuminance.svg">照度
      </div>
      <div class="center">
        {{ editValueToDisplay(destinationSpotState.illuminance, 1) }} lx
      </div>
    </v-ons-list-item>
    -->

  </div>
</template>


<script>
export default {
  computed: {
    destinationSpot: ({ $store }) => $store.state.searchResult.destination,
    destinationSpotState: ({ destinationSpot }) => destinationSpot.spotState,
  },
  beforeCreate() {
    this.chartHeight = window.innerHeight * 0.25;
    this.chartWidth = window.innerWidth - 20;
  },
  methods: {
    editValueToDisplay(value, digits) {
      if (value == null) return '-';
      return Math.round(value * digits) / digits;
    },
    noiseCalculated(value) {
      let noise = '-';

      if (value === 5) {
        noise = 'とても高い';
      } else if (value === 4) {
        noise = '高い';
      } else if (value === 3) {
        noise = 'ふつう';
      } else if (value === 2) {
        noise = '低い';
      } else if (value === 1) {
        noise = 'とても低い';
      }

      return noise;
    },
  },
};
</script>

<style scoped lang="scss">
.env {
  /deep/ {
    .list-item--longdivider:last-of-type {
      border-bottom: 1px solid #ccc;
      border-bottom: none;
      background-size: 100% 1px;
      background-repeat: no-repeat;
      background-position: bottom;
      background-image: linear-gradient(0deg, #ccc, #ccc 100%);
    }
  }
}
.list-label {
  min-width: 140px;
  img {
    width: 30px;
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// spot_environment.vue?e8be41e6